'use strict';

var Backbone = require('backbone');
var _ = require('underscore');

export default Backbone.Model.extend({

  isUncategorized: function () {
    if (!this.has('servicecategory')) {
      return true;
    }

    var categories = this.get('servicecategory');
    if (!_.isArray(categories)) {
      return true;
    }

    return _.isEmpty(categories);
  },

  hasCategory: function (category) {
    if (!this.has('servicecategory')) {
      return false;
    }

    var categories = this.get('servicecategory');
    if (!_.isArray(categories)) {
      return false;
    }

    for (var i = 0; i < categories.length; i++) {
      if (categories[i].id == category.id) {
        return true;
      }
    }

    return false;
  },

  showPrice: function () {
    return window.SETTINGS.enable_payment && this.get('price') > 0;
  },

});
